module.exports = __webpack_public_path__ + "img/gulfcoin.2e912b7c.webp";